var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "line", staticClass: "line" }, [
    _c("div", { staticClass: "track", style: { width: _vm.percent + "%" } }, [
      _c("div", { staticClass: "start" }),
      _vm._v(" "),
      _c("div", { ref: "end", staticClass: "end" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }